import gql from 'graphql-tag'
import projectFragment from '../../fragments/project'

export default gql`mutation go($project_id: String!, $data: [ProjectFeeInput]!){
  upsertProjectFeeRates(project_id: $project_id, data: $data){
    ${projectFragment}
  }
}`